import React from "react";
import {
  ManagerProfileEditingSection,
  useManagerProfile,
} from "../ManagerProfileProvider";
import { ManagerProfileSection } from "../ManagerProfileSection";
import { Flex, Icon } from "@chakra-ui/react";
import { ManagerProfileEmptySection } from "../ManagerProfileEmptySection";
import { ControlsVideoPlayIcon } from "../../../icons";
import { VideoOrImage } from "../../common/VideoOrImage";

export const Video: React.FC = () => {
  const { manager, isEditing, isEditor, setEditingDrawer } =
    useManagerProfile();
  const videoUrl = manager.descriptionVideoUrl;

  return (
    <ManagerProfileSection
      w={"100%"}
      title={"Video"}
      action={() => setEditingDrawer(ManagerProfileEditingSection.Video)}
      showTitle={isEditing}
    >
      {isEditing && !videoUrl && (
        <ManagerProfileEmptySection
          description={"Add a video to showcase your firm."}
          buttonLabel={"Add video"}
          onAction={() => setEditingDrawer(ManagerProfileEditingSection.Video)}
          bg={"transparent"}
        >
          <Flex
            h={"140px"}
            alignItems={"center"}
            justifyContent={"center"}
            bg={"bg.white"}
            cursor={"pointer"}
          >
            <Icon
              as={ControlsVideoPlayIcon}
              boxSize="48px"
              color="border.grey"
            />
          </Flex>
        </ManagerProfileEmptySection>
      )}
      {videoUrl && (
        <VideoOrImage
          video={videoUrl || ""}
          image={manager.descriptionImgUrl || ""}
          isEditor={isEditor}
          managerId={String(manager.id) || ""}
        />
      )}
    </ManagerProfileSection>
  );
};
